// extracted by mini-css-extract-plugin
export default {"imageBlock":"Image_imageBlock__nPH3c","image":"Image_image__aLLkG"};